import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import {
  AuthenticationResult,
  EventType,
  PublicClientApplication,
  InteractionType,
} from '@azure/msal-browser';
import {
  MsalProvider,
  useMsalAuthentication,
} from '@azure/msal-react';
import { msalConfig } from './authConfig';
import Home from './pages/Home/Home';
import Login from './pages/Login/Login';

const msalInstance = new PublicClientApplication(msalConfig);

console.log('in app');

const App = () => {
   useMsalAuthentication(InteractionType.Redirect);
  return (
    <Switch>
      <Route path="/login/callback" component={Login} />
      <Route path="/login" component={Login} />
      <Route path="/" component={Home} />
    </Switch>
  );
};

console.log('all accounts: ', msalInstance.getAllAccounts());
console.log('active account: ', msalInstance.getActiveAccount());

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount()) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  const accounts = msalInstance.getAllAccounts();
  console.log('accounts: ', accounts);
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }
}

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event) => {
  console.log('event in event callback: ', event);
  if (
    event.eventType === EventType.LOGIN_SUCCESS &&
    event.payload &&
    (event.payload as AuthenticationResult).account
  ) {
    const account = (event.payload as AuthenticationResult).account;
    msalInstance.setActiveAccount(account);
  }
});

const Router = () => (
  <BrowserRouter>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </BrowserRouter>
);

export default Router;
